var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var getTrackingInfoForLogging = function (context) {
  var _a;
  var duaid = context === null || context === void 0 ? void 0 : context.deviceId;
  var traceId = (_a = context === null || context === void 0 ? void 0 : context.traceInfo) === null || _a === void 0 ? void 0 : _a['Trace-ID'];
  return " DUAID=".concat(duaid, " , TraceID=").concat(traceId);
};
export var getTrackingInfoForLoggingFromHeaders = function (headers) {
  var duaid = headers === null || headers === void 0 ? void 0 : headers['Device-User-Agent-ID'];
  var traceId = headers === null || headers === void 0 ? void 0 : headers['trace-id'];
  return " DUAID=".concat(duaid, " , TraceID=").concat(traceId);
};
export var getTraceId = function (headers) {
  return headers && headers['trace-id'] || null;
};
export var getMessageId = function (headers) {
  return headers && headers['message-id'] || null;
};
export var getRequestHeaders = function (param) {
  var headers = {};
  var contextHeaders = {};
  if (!param) {
    return headers;
  }
  if ('context' in param && param.context) {
    contextHeaders = {
      'ctx-site-id': param.context.site.id,
      'ctx-site-eapid': param.context.site.eapid,
      'ctx-site-locale': param.context.locale,
      'ctx-site-currency': param.context.currency,
      'ctx-agent-device-id': param.context.deviceId
    };
  } else {
    var context = param;
    contextHeaders = {
      'ctx-site-id': context.siteId,
      'ctx-site-eapid': context.eapid,
      'ctx-site-locale': context.locale,
      'ctx-site-currency': context.currency
    };
  }
  if ('context' in param && param.context.traceInfo) {
    headers = {
      'trace-id': param.context.traceInfo['Trace-ID'],
      // eslint-disable-next-line dot-notation
      'message-id': param.context.traceInfo['Message-ID'],
      // prettier-ignore
      'cookie': param.headers.cookie,
      // prettier-ignore
      'authorization': param.headers.authorization,
      // prettier-ignore
      'x-datadog-trace-id': param.headers['x-datadog-trace-id']
    };
  }
  return __assign(__assign({}, headers), contextHeaders);
};